import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Represents a filter picker component.
 */
import { Select } from '@guildeducationinc/recess';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useFilters } from '../../hooks/useFilters';
import { MuiMultiSelect } from '../MuiMultiSelect/MuiMultiSelect';
/**
 * FilterPicker component.
 * @param props - The component props.
 * @returns The rendered FilterPicker component.
 */
export const FilterPicker = (props) => {
    const intl = useIntl();
    const { items, loading } = useFilters({
        clientId: props.clientId,
        returnType: props.returnType,
    });
    useEffect(() => {
        if (props.value && props.onInit) {
            props.onInit(items?.find(x => String(x.id) === props.value));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);
    /**
     * Handles the change event of the Select component.
     * @param event - The select change event.
     */
    const handleOnChange = (event) => {
        if (props.onChange) {
            if (props.multiple) {
                const selectedValues = event.selection?.map((x) => x.value) ?? [];
                props.onChange(items?.filter(x => selectedValues.includes(String(x.id))));
            }
            else {
                props.onChange(items?.find(x => String(x.id) === event.target.value));
            }
        }
    };
    if (props.useMui && props.multiple) {
        return (_jsx(MuiMultiSelect, { label: props.label ?? '', placeholder: props.placeholder ?? intl.formatMessage({ id: 'filters.select.filter' }), value: props.value, onChange: handleOnChange, options: items?.map(filter => ({ value: String(filter.id), label: filter.name })) ?? [], className: props.className, disabled: props.disabled, errors: props.errors }));
    }
    return (_jsx(_Fragment, { children: !loading && (_jsx(Select, { label: props.label ?? '', helpText: props.helpText, placeholder: props.placeholder ?? intl.formatMessage({ id: 'filters.select.filter' }), onChange: handleOnChange, options: items?.map(filter => ({ value: String(filter.id), label: filter.name })) ?? [], className: props.className, value: props.value, multiple: props.multiple, disabled: props.disabled, errors: props.errors })) }));
};
